import React, { useEffect, useState } from 'react';
import { useListContext } from 'framework/list';
import { FilterSection } from 'domain/shared/oneStop';
import OneStopFilterLayout from 'domain/gpo/oneStop/List/OneStopFilterLayout';
import { useDeviceDetectorService } from 'framework/utils';

type OneStopFilterProps = {
  requestsList: React.ReactChild;
  getSections: () => Promise<FilterSection[]>;
};

const OneStopFilter = ({ getSections, requestsList }: OneStopFilterProps) => {
  const [sections, setSections] = useState<FilterSection[]>([]);
  const { isDesktop } = useDeviceDetectorService();
  const { filter, filterBy } = useListContext();
  const activeFilterId = filter?.section?.eq || null;

  useEffect(() => {
    (async () => {
      const data = await getSections();
      setSections(data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCategoryClick = (id: string) => {
    // @ts-ignore
    filterBy({
      section: {
        eq: id,
      },
    });
  };

  const sectionProps = {
    handleCategoryClick,
    requestsList,
    isDesktop,
    activeFilterId,
  };

  return <OneStopFilterLayout sections={sections} sectionProps={sectionProps} />;
};

export default OneStopFilter;
